export enum TestingStatusCodeEnum {
  // PreCollaudoInCorso = 'DRAFT',
  // PreCollaudoTerminato = 'PRE',
  // CollaudoInCorso = 'WIP',
  // CollaudoSospeso = 'SUSPENDED',
  // CollaudoCompletato = 'COMPLETED',
  PreCollaudoInCorso = '010',
  PreCollaudoTerminato = '020',
  PreCollaudoValidato = '030',
  CollaudoInCorso = '040',
  CollaudoSospeso = '050',
  CollaudoCompletato = '060',
  AltroNonPresente = '099', // verifica se serve
}
export enum TestingTypeCodeEnum {
  AltroNonPresente = 'OTHER',
  Exchange = 'TT4',
  Donazione = 'TT6',
  CollaudoSemplificato = 'TT_ST',
  StudioClinico = 'TT8',
  Acquisto = 'TT1',
  Università = 'TT7',
  Comodato = 'TT5',
  Noleggio = 'TT3',
  Service = 'TT2',
  PresaInCarico = 'TT9',
  Amministrativo = 'TT10',
}

export enum AssetStatusCodeEnum {
  FuoriUso = 'FU',
  InCarico = 'IC',
  InUso = 'IU',
  NonTrovato = 'NT',
}

export enum OrderStatusCodeEnum {
  NonEvaso = 'notEscaped',
  Completato = 'completed',
  ParzialmenteEvaso = 'partial',
}

export enum CorrectiveMaintenanceStatusCodeEnum {
  AperturaChiamata = 'OPE',
  Assegnata = 'ASS',
  Chiusa = 'CLO',
  ChiusaSenzaRapportoTecnico = 'CSR',
  SostituzioneConMuletto = 'MUL',
  Annullata = 'ANN',
  // Sospesa = 'SOS',
  Monitoraggio = 'MON',
  PropostaFuoriUso = 'PFU',
  NonDisponibile = 'ND',
  NonTrovato = 'NT',
  NonApplicabile = 'NA',
}

export enum CorrectiveMaintenanceTypesCodeEnum {
  SpedizioneApparecchiaturaPerRiparazione = 'DA_011',
  InoltrataRichiestaInterventoEsterno = 'DA_021',
  InoltrataRichiestaIntervento = 'DA_015',
}

export enum CorrectiveMaintenanceResultCodeEnum {
  Positivo = 'MCP',
  Negativo = 'MCN',
  NonConforme = 'MCNC',
}

export enum CorrectiveMaintenanceCustomPermissionEnum {
  // CorrectiveMaintenancesFilterebByTechnician = 'read_filtered_mc_for_technician_user',
  CanCancelMaintenance = 'edit_mc_status_canceled',
  CanChangeMaintenanceOpeningData = 'edit_mc_opening_data',
  CanChangeMaintenanceInterventionData = 'edit_mc_intervention_data',
  CanSetMaintenanceStatusToOpen = 'edit_mc_status_to_open',
  // CanSetMaintenanceStatusToAssigned = 'edit_mc_status_to_assigned', NO
  EditClosedMaintenance = 'edit_mc_closed',
  EditOnlyAssignedMaintenance = 'edit_only_assigned_mc',
  EditClosedMaintenanceStatusResult = 'edit_closed_mc_status_result',
}

export enum TestingCustomPermissionEnum {
  ProgressTestingStatus = 'progress_testingStatus',
  ChangeTestingStatus = 'change_testingStatus',
  EditOnlyAssignedTesting = 'edit_only_assigned_testing', // vale sia per il tecnico che per il coordinatore
  EditDocumentsOnly = 'edit_testing_documents_only',
  AssignTechnician = 'assign_technician',
}

export enum ScheduledMaintenanceStatusCodeEnum {
  Pianificata = 'MPP',
  Eseguita = 'MPE',
  NonEseguita = 'MPNE',
  PropostaFuoriUso = 'PFU',
  Annullata = 'MPANN',
  ChiusaSenzaRapportoTecnico = 'MPCSR',
  Monitoraggio = 'MPMON',
  SostituzioneConMuletto = 'MPMUL',
}

export enum ScheduledMaintenanceTypeCodeEnum {
  ManutenzionePreventiva = 'MP',
  ControlloFunzionale = 'CF',
  ControlliBilance = 'CB',
  VerificaSicurezzaElettrica = 'VSE',
}

export enum ScheduledMaintenanceResultCodeEnum {
  Positivo = 'MPP',
  Negativo = 'MPN',
}

export enum CostCenterCodeEnum {
  SicCode = '106112',
}

export enum AssetInterventionPriorityEnum {
  PrioritaLocaliGruppo1 = 'PLG1',
  PrioritaLocaliGruppo2 = 'PLG2',
}

export enum FilterCustomPermissionsEnum {
  FilterAssetByUserCostCenter = 'filter_asset_cost_center',
  FilterCorrectiveMaintenanceByUserCostCenter = 'filter_correctiveMaintenance_cost_center',
  FilterAssetInChargeOfInternal = 'filter_asset_in_charge_of_internal', // per tecnici / coord. tecnici
  // FilterCorrectiveMaintenanceAssetInChargetOfInternal = 'filter_correctiveMaintenance_asset_in_charge_of_internal', // per tecnici / coord. tecnici
  FilterScheduledMaintenanceByUserCostCenter = 'filter_scheduledMaintenance_cost_center',
  FilterMedicalGasRequestCostCenter = 'filter_medicalGasRequest_cost_center',
  FilterRequestByTechnicalCompetence = 'filter_request_by_technical_competence',
}

export enum RoleCodeEnum {
  SuperAdmin = 'superAdmin',
  Fornitore = 'fornitore',
  DirezioneSic = 'direzioneSic',
  ReferenteTecniciSic = 'referenteTecniciSic',
  TecnicoSic = 'tecnicoSic',
  Magazziniere = 'magazziniere',
  UtenteDiReparto = 'utenteDiReparto',
  OperatoreAmministrativoSic = 'operatoreAmministrativoSic',
  DirettoreMedicoDelPresidio = 'direttoreMedicoDelPresidio',
  DirettoreDiReparto = 'direttoreDiReparto',
  CoswinImporter = 'coswinImporter', // solo per import, da associare a utente con sua api key
  FornitoreGasMedicali = 'fornitoreGasMedicali',
  DirezioneGestioneLogistica = 'direzioneGestioneLogistica',
  DirezioneServizioTecnicoPatrimoniale = 'direzioneServizioTecnicoPatrimoniale',
  DirezioneSia = 'direzioneSia',
  Farmacia = 'farmacia',
  UtenteLetturaAsset = 'utenteLetturaAsset',
  TecnicoGlobalService = 'tecnicoGlobalService', // utente tecnico GS che entra in AM
  EasiImporter = 'easiImporter', // solo per import, da associare a utente con sua api key
  DirezioneMedicaStrumentario = 'direzioneMedicaStrumentario', // nuovo ruolo per i moduli AssetOrAccessoryRequest
  SCGestioneAcquisti = 'scGestioneAcquisti', // nuovo ruolo per i moduli AssetOrAccessoryRequest
  PersonaleDirezioneMedica = 'personaleDirezioneMedica', // nuovo ruolo per i moduli richiesta
}

export enum ScheduledMaintenanceCustomPermissionEnum {
  // CorrectiveMaintenancesFilterebByTechnician = 'read_filtered_mp_for_technician_user',
  // CanCancelMaintenance = 'edit_mp_status_canceled', NO
  //CanSetMaintenanceStatusToOpen = 'edit_mp_status_to_open', No
  //CanSetMaintenanceStatusToAssigned = 'edit_mp_status_to_assigned', NO
  CanChangeMaintenanceOpeningData = 'edit_mp_opening_data',
  CanChangeMaintenanceInterventionData = 'edit_mp_intervention_data',
  EditClosedMaintenance = 'edit_mp_closed',
  EditOnlyAssignedMaintenance = 'edit_only_assigned_mp',
  EditClosedMaintenanceStatusResult = 'edit_closed_mp_status_result',
}

// valori di default impostati se in fase di import iniziale i campi sono vuoti
export enum DefaultValuesEnum {
  EndWarrantyDate = '1900-01-01',
  WarrantyMonths = -1,
}

export enum AssetAvailabilityCodeEnum {
  'Sempre' = 0,
  'Entro le ore 14:00' = 1,
  'Dopo le ore 14:00' = 2,
  'A partire da domani' = 3,
  'Da pianificare' = 4,
}

export enum CorrectiveMaintenanceViewEnum {
  Mine = 0,
  Internal = 1,
  GlobalService = 2,
  All = 3,
}

export enum ModuleActionEnum {
  print = 'print',
  save = 'save',
}

export enum SupplierContactTypeEnum {
  NonSpecificato = 4,
  TestingEmail = 1,
  MaintenanceEmail = 2,
  TestingAndMaintenanceEmail = 3,
}

export const SupplierContactTypeValues = [
  {
    value: SupplierContactTypeEnum.NonSpecificato,
    description: 'Non specificato',
  },
  {
    value: SupplierContactTypeEnum.TestingEmail,
    description: 'Collaudo',
  },
  {
    value: SupplierContactTypeEnum.MaintenanceEmail,
    description: 'Manutenzione',
  },
  {
    value: SupplierContactTypeEnum.TestingAndMaintenanceEmail,
    description: 'Collaudo e manutenzione',
  },
];

// nuovo GS Althea (GlobalServiceCode)
// export const PolygonCode = 'A0421';
export const GlobalServiceCode = 'A0802';
export const DominioGSEmail = 'althea-group.com';

export const REFRESH_TOKEN_ERROR = 'REFRESH_TK_ERROR';

export const VpnRequestDocumentTypeCode = 'RICHIESTA_VPN';

export const TrainingDocumentTypeCode = 'TRAINING';

export const VpnRequestApplicantDefaultData = {
  reparto: 'S.C. Ingegneria Clinica',
  nomeReferente: 'Claudia Duri',
  badgeReferente: '18374',
  qualificaReferente: 'Collaboratore Tecnico Professionale',
  emailReferente: 'claudia.duri@asst-spedalicivili.it',
  telefonoReferente: '0303996904',
};

// Richiesta Apparecchiature o accessori

export enum AssetOrAccessoryRequestTypeEnum {
  Elettromedicali = 'module_8',
  TecnicoEconomali = 'module_9',
  AccessoriDispositiviMedici = 'module_10',
  SistemaDiIntelligenzaArtificiale = 'module_8ter',
  Strumentario = 'module_8bis',
}

export const AssetOrAccessoryRequestType = [
  {
    value: AssetOrAccessoryRequestTypeEnum.Elettromedicali,
    description: 'Apparecchiature elettromedicali',
  },
  {
    value: AssetOrAccessoryRequestTypeEnum.TecnicoEconomali,
    description: 'Apparecchiature tecnico-economali ed Elettrodomestici',
  },
  {
    value: AssetOrAccessoryRequestTypeEnum.AccessoriDispositiviMedici,
    description: 'Accessori/Dispositivi medici/Beni',
  },
  // {
  //   value:
  //     AssetOrAccessoryRequestTypeEnum.SistemaDiIntelligenzaArtificiale,
  //   description: 'Strumenti con sistema di Intelligenza Artificiale',
  // },
  // {
  //   value: AssetOrAccessoryRequestTypeEnum.Strumentario,
  //   description: 'Strumentario',
  // },
];

export enum AOARequestProductTypeEnum {
  DM = 'DM',
  IVD = 'IVD',
  ID = 'ID',
  RUO = 'RUO',
  DPI = 'DPI',
  APE = 'APE',
  SC = 'SC',
  DMNSP = 'DMNSP',
  APA = 'APA',
  AGM = 'AGM',
  DPIL = 'DPIL',
  PE = 'PE',
}

export const AOARequestProductType = [
  {
    value: AOARequestProductTypeEnum.DM,
    description: 'Dispositivo medico',
  },
  {
    value: AOARequestProductTypeEnum.IVD,
    description: 'Dispositivo diagnostico in vitro',
  },
  {
    value: AOARequestProductTypeEnum.ID,
    description: 'Dispositivo impiantabile',
  },
  {
    value: AOARequestProductTypeEnum.RUO,
    description: 'Research use only',
  },
  {
    value: AOARequestProductTypeEnum.DPI,
    description: 'Dispositivo di protezione individuale',
  },
  {
    value: AOARequestProductTypeEnum.DPIL,
    description:
      'Dispositivo di protezione individuale (tute, visiere, occhiali e anti RX)',
  },
  {
    value: AOARequestProductTypeEnum.APE,
    description: 'Arredi e ausili',
  },
  {
    value: AOARequestProductTypeEnum.PE,
    description: 'Presidi economali',
  },
  {
    value: AOARequestProductTypeEnum.SC,
    description: 'Stampati e cancelleria',
  },
  {
    value: AOARequestProductTypeEnum.DMNSP,
    description: 'Dispositivo medico non sterile pluriuso/sterile classe I',
  },
  {
    value: AOARequestProductTypeEnum.APA,
    description: 'Accessori pluriuso apparecchiature',
  },
  {
    value: AOARequestProductTypeEnum.AGM,
    description: 'Accessori Gas Medicali',
  },
];

export const FarmaciaProductType = [
  {
    value: AOARequestProductTypeEnum.DM,
    description: 'Dispositivo medico',
  },
  {
    value: AOARequestProductTypeEnum.IVD,
    description: 'Dispositivo diagnostico in vitro',
  },
  {
    value: AOARequestProductTypeEnum.ID,
    description: 'Dispositivo impiantabile',
  },
  {
    value: AOARequestProductTypeEnum.RUO,
    description: 'Research use only',
  },
  {
    value: AOARequestProductTypeEnum.DPI,
    description: 'Dispositivo di protezione individuale',
  },
];

export const LogisticaProductType = [
  {
    value: AOARequestProductTypeEnum.APE,
    description: 'Arredi e ausili',
  },
  {
    value: AOARequestProductTypeEnum.PE,
    description: 'Presidi economali',
  },
  {
    value: AOARequestProductTypeEnum.SC,
    description: 'Stampati e cancelleria',
  },
  {
    value: AOARequestProductTypeEnum.DMNSP,
    description: 'Dispositivo medico non sterile pluriuso/sterile classe I',
  },
  {
    value: AOARequestProductTypeEnum.DPIL,
    description:
      'Dispositivo di protezione individuale (tute, visiere, occhiali e anti RX)',
  },
];

export const DirezioneSicProductType = [
  {
    value: AOARequestProductTypeEnum.APA,
    description: 'Accessori pluriuso apparecchiature',
  },
  {
    value: AOARequestProductTypeEnum.AGM,
    description: 'Accessori Gas Medicali',
  },
];

export enum UfficioDiCompetenzaEnum {
  Farmacia = 'Farmacia',
  DirezioneGestioneLogistica = 'DirezioneGestioneLogistica',
  DirezioneSic = 'DirezioneSic',
}

export const UfficioDiCompetenza = [
  {
    value: UfficioDiCompetenzaEnum.Farmacia,
    description: 'Farmacia',
  },
  {
    value: UfficioDiCompetenzaEnum.DirezioneGestioneLogistica,
    description: 'Direzione Gestione Logistica',
  },
  {
    value: UfficioDiCompetenzaEnum.DirezioneSic,
    description: 'Direzione SIC',
  },
];

export const UfficioDiCompetenzaRadio = [
  {
    value: UfficioDiCompetenzaEnum.Farmacia,
    label: 'Farmacia',
  },
  {
    value: UfficioDiCompetenzaEnum.DirezioneGestioneLogistica,
    label: 'Direzione Gestione Logistica',
  },
  {
    value: UfficioDiCompetenzaEnum.DirezioneSic,
    label: 'Direzione SIC',
  },
];
export enum AssetOrAccessoryRequestStatusEnum {
  RichiestaPresentata = 'RichiestaPresentata',
  ParereDirezioneReparto = 'ParereDirezioneReparto',
  ParereDirezionePresidio = 'ParereDirezionePresidio',
  ParereDirezioneMedicaStrumentario = 'ParereDirezioneMedicaStrumentario',
  PresaInCaricoDirezioneSic = 'PresaInCaricoDirezioneSic',
  ParereDirezioneSic = 'ParereDirezioneSic',
  PresaInCaricoDirezioneGestioneLogistica = 'PresaInCaricoDirezioneGestioneLogistica',
  ParereDirezioneGestioneLogistica = 'ParereDirezioneGestioneLogistica',
  PresaInCaricoUfficioDiCompetenza = 'PresaInCaricoUfficioDiCompetenza',
  ParereUfficioDiCompetenza = 'ParereUfficioDiCompetenza',
  EmissioneProposta = 'EmissioneProposta',
  CommentoGestioneAcquisti = 'CommentoGestioneAcquisti',
}

export const AssetOrAccessoryRequestStatus = [
  {
    value: AssetOrAccessoryRequestStatusEnum.RichiestaPresentata,
    description: 'Richiesta Presentata',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.ParereDirezioneReparto,
    description: 'Parere Direzione di Reparto',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.ParereDirezionePresidio,
    description: 'Parere Direzione Medica di Presidio',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.ParereDirezioneMedicaStrumentario,
    description: 'Parere Direzione Medica Strumentario',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.PresaInCaricoDirezioneSic,
    description: 'Presa in carico Direzione SIC',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.ParereDirezioneSic,
    description: 'Parere Direzione SIC',
  },
  {
    value:
      AssetOrAccessoryRequestStatusEnum.PresaInCaricoDirezioneGestioneLogistica,
    description: 'Presa in carico Direzione Gestione Logistica',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.ParereDirezioneGestioneLogistica,
    description: 'Parere Direzione Gestione Logistica',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.PresaInCaricoUfficioDiCompetenza,
    description: 'Presa in carico Ufficio di Competenza',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.ParereUfficioDiCompetenza,
    description: 'Parere Ufficio di Competenza',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.EmissioneProposta,
    description: 'Emissione Proposta',
  },
  {
    value: AssetOrAccessoryRequestStatusEnum.CommentoGestioneAcquisti,
    description: 'Commento Gestione Acquisti',
  },
];

export enum ReplacementOrIntegrationEnum {
  Replacement = 'Replacement',
  Integration = 'Integration',
}

export const ReplacementOrIntegration = [
  {
    value: ReplacementOrIntegrationEnum.Integration,
    description: 'Integrare la dotazione',
  },
  {
    value: ReplacementOrIntegrationEnum.Replacement,
    description: "Sostituire un'apparecchiatura",
  },
];

export enum ReplacementReasonEnum {
  FuoriUso = 'FuoriUso',
  FurtoSmarrimento = 'FurtoSmarrimento',
  Altro = 'Altro',
}

export const ReplacementReason = [
  {
    value: ReplacementReasonEnum.FuoriUso,
    description: 'Fuori Uso',
  },
  {
    value: ReplacementReasonEnum.FurtoSmarrimento,
    description: 'Furto/Smarrimento (allegare denuncia)',
  },
  {
    value: ReplacementReasonEnum.Altro,
    description: 'Altro (specificare)',
  },
];

export enum AcquisitionMethodEnum {
  Acquisto = 'Acquisto',
  Noleggio = 'Noleggio',
  Service = 'Service',
  ComodatoUso = 'ComodatoUso',
  StudioClinico = 'StudioClinico',
  AcquistoPerBackOrder = 'AcquistoPerBackOrder',
  Altro = 'Altro',
}

export const AcquisitionMethod = [
  {
    value: AcquisitionMethodEnum.Acquisto,
    description: 'Acquisto',
  },
  {
    value: AcquisitionMethodEnum.Noleggio,
    description: 'Noleggio',
  },
  {
    value: AcquisitionMethodEnum.Service,
    description: 'Service',
  },
  {
    value: AcquisitionMethodEnum.ComodatoUso,
    description: 'Comodato d’uso',
  },
  {
    value: AcquisitionMethodEnum.StudioClinico,
    description: 'Studio Clinico',
  },
  {
    value: AcquisitionMethodEnum.AcquistoPerBackOrder,
    description: 'Acquisto per Back Order',
  },
  {
    value: AcquisitionMethodEnum.Altro,
    description: 'Altro (specificare)',
  },
];

export enum PurchaseMethodEnum {
  ContoDeposito = 'ContoDeposito',
  Transito = 'Transito',
  Giacenza = 'Giacenza',
}

export const PurchaseMethod = [
  {
    value: PurchaseMethodEnum.ContoDeposito,
    description: 'Conto Deposito',
  },
  {
    value: PurchaseMethodEnum.Transito,
    description: 'Transito',
  },
  {
    value: PurchaseMethodEnum.Giacenza,
    description: 'Giacenza',
  },
];

export enum AssetOrAccessoriesViewEnum {
  Elettromedicali = 0,
  TecnicoEconomali = 1,
  AccessoriDM = 2,
  All = 3,
  AppAI = 4,
  Strumentario = 5,
}

export enum OpinionEnum {
  Favorevole = 'Favorevole',
  Contrario = 'Contrario',
  InSospeso = 'InSospeso',
  InLavorazione = 'InLavorazione',
  NonDiCompetenza = 'NonDiCompetenza',
  ParereAccessoriFornito = 'ParereAccessoriFornito',
  ParereApparecchiatureFornito = 'ParereApparecchiatureFornito',
  ElencoPriorita = 'ElencoPriorita',
}

export const Opinion = [
  {
    value: OpinionEnum.Favorevole,
    description: 'Favorevole',
  },
  {
    value: OpinionEnum.Contrario,
    description: 'Contrario',
  },
  {
    value: OpinionEnum.InSospeso,
    description: 'In sospeso',
  },
  {
    value: OpinionEnum.InLavorazione,
    description: 'In lavorazione',
  },
  {
    value: OpinionEnum.NonDiCompetenza,
    description: 'Non di competenza',
  },
  {
    value: OpinionEnum.ParereAccessoriFornito,
    description: 'Parere Accessori Fornito',
  },
  {
    value: OpinionEnum.ParereApparecchiatureFornito,
    description: 'Parere Apparecchiature Fornito',
  },
  {
    value: OpinionEnum.ElencoPriorita,
    description: 'Elenco priorità',
  },
];

export enum AssetDestinationEnum {
  Dismissione = 'Dismissione',
  Rottamazione = 'Rottamazione',
}

export const AssetDestination = [
  {
    value: AssetDestinationEnum.Dismissione,
    description: 'Dismissione',
  },
  {
    value: AssetDestinationEnum.Rottamazione,
    description: 'Rottamazione',
  },
];

export enum ValutazioneTecnicoSicScaricoEnum {
  FuoriUso = 'FuoriUso',
  TrasferimentoIC = 'TrasferimentoIC',
}

export const ValutazioneTecnicoSicScarico = [
  {
    value: ValutazioneTecnicoSicScaricoEnum.FuoriUso,
    description: 'Fuori Uso',
  },
  {
    value: ValutazioneTecnicoSicScaricoEnum.TrasferimentoIC,
    description: 'Trasferimento IC',
  },
];

export const CdcICCode = '106112';
export const LocICcode = 'A2000';
export const MUICCode = 'A';

// Richiesta trasferimento o scarico
export enum TransferOrUnloadingViewEnum {
  Trasferimento = 0,
  Scarico = 1,
  ScaricoFuoriUso = 2,
  All = 3,
}

export enum TransferOrUnloadingRequestTypeEnum {
  Trasferimento = 'module_20',
  Scarico = 'module_20_ic',
  ScaricoFuoriUso = 'module_20_ic,module_22',
}

export const TransferOrUnloadingRequestType = [
  {
    value: TransferOrUnloadingRequestTypeEnum.Trasferimento,
    description: 'Trasferimento apparecchiature/altro ad altro reparto',
  },
  {
    value: TransferOrUnloadingRequestTypeEnum.Scarico,
    description: 'Scarico apparecchiature/altro per obsolescenza',
  },
  {
    value: TransferOrUnloadingRequestTypeEnum.ScaricoFuoriUso,
    description: 'Scarico apparecchiatura per irreparabilità (fuori uso)',
  },
];

export enum TransferOrUnloadingRequestResultEnum {
  CespiteModificato = 'CespiteModificato',
  CespiteEliminato = 'CespiteEliminato',
}

export const TransferOrUnloadingRequestResult = [
  {
    value: TransferOrUnloadingRequestResultEnum.CespiteModificato,
    description: 'Cespite Modificato',
  },
  {
    value: TransferOrUnloadingRequestResultEnum.CespiteEliminato,
    description: 'Cespite Eliminato',
  },
];

export enum TransferOrUnloadingRequestStatusEnum {
  RichiestaPresentata = 'RichiestaPresentata',
  ParereRepartoAccettante = 'ParereRepartoAccettante',
  ValutazioneTecnicaAssegnata = 'ValutazioneTecnicaAssegnata',
  ParereDirezioneSic = 'ParereDirezioneSic',
  ParereTecnicoSic = 'ParereTecnicoSic',
  ValutazioneTecnica = 'ValutazioneTecnica',
  ConfermaGestioneLogistica = 'ConfermaGestioneLogistica',
}

export const TransferOrUnloadingRequestStatus = [
  {
    value: TransferOrUnloadingRequestStatusEnum.RichiestaPresentata,
    description: 'Richiesta Presentata',
  },
  {
    value: TransferOrUnloadingRequestStatusEnum.ParereRepartoAccettante,
    description: 'Parere Reparto accettante',
  },
  {
    value: TransferOrUnloadingRequestStatusEnum.ParereDirezioneSic,
    description: 'Parere Direzione SIC',
  },
  {
    value: TransferOrUnloadingRequestStatusEnum.ValutazioneTecnicaAssegnata,
    description: 'Valutazione Tecnica Assegnata',
  },
  {
    value: TransferOrUnloadingRequestStatusEnum.ValutazioneTecnica,
    description: 'Parere Valutazione Tecnica',
  },
  {
    value: TransferOrUnloadingRequestStatusEnum.ParereTecnicoSic,
    description: 'Parere Tecnico SIC',
  },
  {
    value: TransferOrUnloadingRequestStatusEnum.ConfermaGestioneLogistica,
    description: 'Conferma Gestione Logistica',
  },
];

// AssetOrOtherEnum
export enum AssetOrOtherEnum {
  Asset = 'Asset',
  Other = 'Other',
}

export const AssetOrOther = [
  {
    value: AssetOrOtherEnum.Asset,
    description: 'Apparecchiatura',
  },
  {
    value: AssetOrOtherEnum.Other,
    description: 'Altro bene',
  },
];

// TechnicalAssessmentOfCompetence
export enum TechnicalAssessmentOfCompetenceEnum {
  DirezioneMedica = 'DirezioneMedica',
  DirezioneGestioneLogistica = 'DirezioneGestioneLogistica',
  DirezioneServizioTecnicoPatrimoniale = 'DirezioneServizioTecnicoPatrimoniale',
  DirezioneSia = 'DirezioneSia',
  DirezioneSic = 'DirezioneSic',
}

export const TechnicalAssessmentOfCompetence = [
  {
    value: TechnicalAssessmentOfCompetenceEnum.DirezioneMedica,
    description: 'Direzione Medica',
  },
  {
    value: TechnicalAssessmentOfCompetenceEnum.DirezioneGestioneLogistica,
    description: 'Direzione Gestione Logistica',
  },
  {
    value:
      TechnicalAssessmentOfCompetenceEnum.DirezioneServizioTecnicoPatrimoniale,
    description: 'Direzione Servizio Tecnico Patrimoniale',
  },
  {
    value: TechnicalAssessmentOfCompetenceEnum.DirezioneSia,
    description: 'Direzione SIA',
  },
  {
    value: TechnicalAssessmentOfCompetenceEnum.DirezioneSic,
    description: 'Direzione SIC',
  },
];

// OutOfOrderAssetRequest
export enum OutOfOrderAssetRequestStatusEnum {
  RichiestaPresentata = 'RichiestaPresentata',
  ParereTecnicoSic = 'ParereTecnicoSic',
  ParereDirezioneSic = 'ParereDirezioneSic',
}

export const OutOfOrderAssetRequestStatus = [
  {
    value: OutOfOrderAssetRequestStatusEnum.RichiestaPresentata,
    description: 'Richiesta Presentata',
  },
  {
    value: OutOfOrderAssetRequestStatusEnum.ParereTecnicoSic,
    description: 'Parere Tecnico SIC',
  },
  {
    value: OutOfOrderAssetRequestStatusEnum.ParereDirezioneSic,
    description: 'Parere Direzione SIC',
  },
];

export enum OutOfOrderAssetRequestOpinionEnum {
  AccettaFU = 'AccettaFU',
  RifiutaFU = 'RifiutaFU',
}

export const OutOfOrderAssetRequestOpinion = [
  {
    value: OutOfOrderAssetRequestOpinionEnum.AccettaFU,
    description: 'Accetta Fuori Uso',
  },
  {
    value: OutOfOrderAssetRequestOpinionEnum.RifiutaFU,
    description: 'Rifiuta Fuori Uso',
  },
];

export enum OutOfOrderAssetDestinationEnum {
  Ricambio = 'Ricambio',
  Muletto = 'Muletto',
  RitiratoDalFornitore = 'RitiratoDalFornitore',
  Macero = 'Macero',
  Altro = 'Altro',
}

export const OutOfOrderAssetDestination = [
  {
    value: OutOfOrderAssetDestinationEnum.Ricambio,
    description: 'Ricambio',
  },
  {
    value: OutOfOrderAssetDestinationEnum.Muletto,
    description: 'Muletto',
  },
  {
    value: OutOfOrderAssetDestinationEnum.RitiratoDalFornitore,
    description: 'Ritirata dal fornitore',
  },
  {
    value: OutOfOrderAssetDestinationEnum.Macero,
    description: 'Macero',
  },
  {
    value: OutOfOrderAssetDestinationEnum.Altro,
    description: 'Altro (specificare)',
  },
];

export enum OutOfOrderAssetCauseEnum {
  ZDEF = 'ZDEF',
  SOST = 'SOST',
  FCOM = 'FCOM',
  NADG = 'NADG',
  IRR = 'IRR',
  NUSO = 'NUSO',
  OBS = 'OBS',
  NTROV = 'NTROV',
  ECO = 'ECO',
  IND = 'IND',
}

export const OutOfOrderAssetCause = [
  {
    value: OutOfOrderAssetCauseEnum.ZDEF,
    description: 'NON DEFINITO',
  },
  {
    value: OutOfOrderAssetCauseEnum.SOST,
    description: 'Apparecchio sostituito',
  },
  {
    value: OutOfOrderAssetCauseEnum.FCOM,
    description: 'Fine service/comodato',
  },
  {
    value: OutOfOrderAssetCauseEnum.NADG,
    description: 'Apparecchio fuori norma non adeguabile',
  },
  {
    value: OutOfOrderAssetCauseEnum.IRR,
    description: 'Irreparabilità',
  },
  {
    value: OutOfOrderAssetCauseEnum.NUSO,
    description: 'Apparecchio non più in uso',
  },
  {
    value: OutOfOrderAssetCauseEnum.OBS,
    description: 'Apparecchio obsoleto',
  },
  {
    value: OutOfOrderAssetCauseEnum.NTROV,
    description: 'Apparecchio non reperibile da almeno 2 anni',
  },
  {
    value: OutOfOrderAssetCauseEnum.ECO,
    description: 'Antieconomicità della riparazione',
  },
  {
    value: OutOfOrderAssetCauseEnum.IND,
    description: 'Ricambi non più disponibili',
  },
];

export const FuoriUsoDocumentTypeCode = 'FU';

// MedicalGasRequest

export enum MedicalGasRequestStatusCodeEnum {
  'Aperta' = 0,
  'Chiusa' = 1,
}
export enum MedicalGasRequestAvailabilityCodeEnum {
  'Sempre' = 0,
  'Entro le ore 14:00' = 1,
  'Dopo le ore 14:00' = 2,
  'A partire da domani' = 3,
  'Da pianificare' = 4,
}

export enum MedicalGasRequestPriorityCodeEnum {
  'Ordinaria' = 0,
  'Bloccante' = 1,
  'Urgente' = 2,
}

// Presidi per Gas Medicali
export enum PresidiGasMedicaliEnum {
  BRESCIA = 'BRESCIA',
  GARDONE = 'GARDONE',
  MONTICHIARI = 'MONTICHIARI',
}

export const PresidiGasMedicaliValues = [
  {
    value: PresidiGasMedicaliEnum.BRESCIA,
    description: PresidiGasMedicaliEnum.BRESCIA.valueOf(),
  },
  {
    value: PresidiGasMedicaliEnum.GARDONE,
    description: PresidiGasMedicaliEnum.GARDONE.valueOf(),
  },
  {
    value: PresidiGasMedicaliEnum.MONTICHIARI,
    description: PresidiGasMedicaliEnum.MONTICHIARI.valueOf(),
  },
];

// tipologia contratto
export enum ContractTypeEnum {
  FULLRISK = 'FULL RISK',
  FULLRISK_PARTNER = 'FULL RISK in formula partner',
  MP = 'MANUTENZIONE PREVENTIVA',
  SOLO_RICAMBI = 'SOLO RICAMBI',
}

export const ContractTypeValues = [
  {
    value: ContractTypeEnum.FULLRISK,
    description: ContractTypeEnum.FULLRISK.valueOf(),
  },
  {
    value: ContractTypeEnum.FULLRISK_PARTNER,
    description: ContractTypeEnum.FULLRISK_PARTNER.valueOf(),
  },
  {
    value: ContractTypeEnum.MP,
    description: ContractTypeEnum.MP.valueOf(),
  },
  {
    value: ContractTypeEnum.SOLO_RICAMBI,
    description: ContractTypeEnum.SOLO_RICAMBI.valueOf(),
  },
];

export const CodiceTipologiaNonSpecificata = 'XXX';

// data inizio AM
export const AMStartDate = new Date(2024, 4, 24); // 24 maggio 2024

export enum ReferenceDateFieldEnum {
  OpenClosed = 'TotalWorkingOpenClosedHours',
  OpenEndIntervention = 'TotalWorkingOpenEndInterventionHours',
  AssignedClosed = 'TotalWorkingAssignedClosedHours',
  AssignedEndIntervention = 'TotalWorkingAssignedEndInterventionHours',
}

export const ReferenceDateFieldValues = [
  {
    value: ReferenceDateFieldEnum.OpenClosed,
    description: 'Data apertura chiamata - Data chiusura chiamata',
  },
  {
    value: ReferenceDateFieldEnum.OpenEndIntervention,
    description: 'Data apertura chiamata - Data fine intervento',
  },
  {
    value: ReferenceDateFieldEnum.AssignedClosed,
    description: 'Data assegnazione chiamata - Data chiusura chiamata',
  },
  {
    value: ReferenceDateFieldEnum.AssignedEndIntervention,
    description: 'Data assegnazione chiamata - Data fine intervento',
  },
];

export interface StatisticsResult {
  chiuseEntroTempi: number;
  chiuseOltreTempi: number;
  aperte: number;
  totali: number;
}

export interface StatisticsDelayResult {
  numeroRange: number;
  descrizione: string;
  record: number;
}

export const BooleanOptionValues = [
  {
    value: false,
    description: 'No',
  },
  {
    value: true,
    description: 'Sì',
  },
];

// Ruoli dei soggetti coinvolti delle richieste: gli enum stanno in @ellf/common-dto, insieme al
// mapping dei campi (common-dto non può importare da common-utils: creerebbe un ciclo)
export {
  AssetOrAccessoryRequestParticipantRole,
  TransferOrUnloadingRequestParticipantRole,
} from '@ellf/common-dto';
